<template>
 <div class="aboutUs">
    <slider animation="fade" :interval="3000">
      <slider-item><img src="@/assets/images/banner_aboutUs.jpeg" height="100%"></slider-item>
    </slider>
    <div class="module pingtai">
      <h1 class="title">平台介绍</h1>
      <div class="content platform">
        <div class="contentWidth">
          <label id="gongyinglian">面向合作伙伴，董妈咪是--<strong>母婴B2B供应链平台</strong></label>
          <div class="des">
            <p>董妈咪平台可实现代理商与上下游供应商直接订货,帮助代理商对下辖门店惊醒智能管理</p>
            <p>为代理商的下辖门店提供动销方案，拉动门店订货</p>
          </div>
        </div>
        <div class="contentWidth introduce clearfix">
          <div class="item item1 fleft">一站式订货平台</div>
          <div class="item item2 fleft">多品牌产品矩阵</div>
          <div class="item item3 fleft">两级进销存</div>
          <div class="item item4 fleft">下辖门店运营支持</div>
        </div>
      </div>
      <div class="content platform m_70">
        <div class="contentWidth">
          <label  id="zhinengyunying">面向商家门店，董妈咪是--<strong>母婴门店智能运营平台</strong></label>
          <div class="des">
            <p>羊村董妈咪，可帮门店运营动销，给门店输出、帮门店开发并找到消费者，专注提升母婴门店销售力</p>
          </div>
        </div>
        <div class="contentWidth introduce clearfix">
          <div class="itemDes fleft">
            <div class="desLabel">优选品牌一键订货</div>
            <div class="des">
              <p>产品矩阵完备</p>
              <p>供货渠道稳定</p>
              <p>产品质量无忧</p>
            </div>
          </div>
          <div class="itemDes fleft">
            <div class="desLabel">门店运营支持</div>
            <div class="des">
              <p>消费者开发引流至门店</p>
              <p>智能CRM消费者运营</p>
              <p>门店持续曝光</p>
              <p>门店动销支持</p>
            </div>
          </div>
          <div class="itemDes fleft">
            <div class="desLabel">数据化运营管理</div>
            <div class="des">
              <p>智慧布局终端网点</p>
              <p>智能选品</p>
              <p>一键管理门店</p>
            </div>
          </div>
        </div>
      </div>
      <div class="content platform m_70">
        <div class="contentWidth">
          <label id="service">面向消费者，董妈咪是--<strong>消费者母婴服务平台</strong></label>
          <div class="des">
            <p>董妈咪向消费者提供尊享优惠，闪电配送等专属会员服务，定期输出母婴育儿知识，成千上万的消费者主动聚集在董妈咪妈妈圈进行交流与分享</p>
          </div>
        </div>
        <div class="contentWidth introduce customer clearfix">
          <div class="item item1 fleft">专属会员服务</div>
          <div class="item item2 fleft">产品积分平台</div>
          <div class="item item3 fleft">母婴知识交流</div>
          <div class="item item4 fleft">活跃社群妈妈圈</div>
        </div>
      </div>
      <div class="content platform m_80">
        <div class="video">
          <video poster="@/assets/images/shipin_JPG.png" controls="controls">
            <source src="@/assets/images/dongmami_aboutus.mp4" type="video/mp4">
            <source src="@/assets/images/dongmami_aboutus.webm" type="video/webm">
          </video>
        </div>
      </div>
    </div>
    <div class="module guanxi">
      <div class="title"><strong>羊村集团───</strong>西安羊羊村落乳业集团有限公司</div>
        <div class="content platform">
          <div class="contentWidth">
            <p>羊村集团----消费者产权模式开创者，创新推出连接线上线下的“董妈咪”母婴数据智能平台，打破门店传统经营方式，运营互联网大数据，帮助门店引流、</p>
            <p>运营、维系消费者；数据化监控门店运营状态，阶段性开展门店运营培训，提升母婴门店运营水平</p>
        </div>
      </div>
    </div>
    <div class="module liucheng">
      <div class="title">董妈咪绑定流程</div>
        <div class="content platform m_80">
          <div class="bind clearfix">
            <div class="item">
              <p>扫描二维码或关注【董妈咪商家版】微信公众号</p>
            </div>
            <div class="item">
              <p>点击任意菜单（或提示）进行门店注册</p>
            </div>
            <div class="item">
              <p>完善门店信息完成注册</p>
            </div>
        </div>
      </div>
    </div>
 </div>
</template>
<script>
import { Slider, SliderItem } from 'vue-easy-slider'

export default {
  name: 'aboutUs',
  data () {
    return {

    }
  },
  mounted () {
    var element = this.$route.hash
    if (element !== '') {
      var dd = document.getElementById(element.split('#')[1])
      dd.scrollIntoView()
    }
  },
  components: {
    Slider,
    SliderItem
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='less' scoped>
.aboutUs{
  .video{
    width: 1280px;
    height: 720px;
    margin: 0 auto;
    video{
      width: 100%;
      height: 100%;
    }
  }
  .w870{
    width: 870px;
    margin: 0 auto;
  }
  .slider {
    width: 100% !important;
    height: 450px !important;
    img{
      width: 100%;
      height: 100%;
    }
  }
  .module{
    padding: 96px 0 90px 0;
    .title{
      text-align: center;
      font-weight: normal;
      font-size: 26px;
      color:#333;
      background: url(../assets/images/line.png) bottom center no-repeat;
      padding-bottom: 22px;
    }
    .subTitle{
      text-align: center;
      font-size: 20px;
      color: #4d4d4d;
      padding:12px 0 170px 0;
    }
    .platform{
      text-align: center;
      margin-top: 74px;
      label{
        display: block;
        height: 30px;
        line-height: 30px;
        margin-bottom: 10px;
        font-size: 20px;
      }
      h3{
        height: 38px;
        line-height: 38px;
      }
      p{
        height: 30px;
        line-height: 30px;
      }
      .introduce{
        margin: 27px auto 36px;
        .item{
          width: 210px;
          height: 94px;
          line-height: 94px;
          margin-right: 86px;
          color: #fff;
          font-size: 16px;

          &.item1{
             background: url("../assets/images/plat_icon1.png");
             text-indent: 50px;
          }
          &.item2{
             background: url("../assets/images/plat_icon2.png");
             text-indent: 50px;
          }
          &.item3{
             background: url("../assets/images/plat_icon3.png");
             text-indent: 82px;
          }
          &.item4{
             background: url("../assets/images/plat_icon4.png");
             text-indent: 34px;
             margin-right: 0px;
          }
        }
        .itemDes{
          text-align: center;
          width: 236px;
          height: 191px;
          background: url("../assets/images/about_p.png");
          margin-right: 196px;
          &.itemDes:last-child{
            margin-right: 0;
          }
          .desLabel{
            height: 41px;
            line-height: 41px;
            color: #fff;
            font-size: 18px;
          }
          .des{
            margin-top: 13px;
          }
          .desc{
            display: inline-block;
            vertical-align: middle;
            margin: 0 auto;
          }
        }
        &.customer{
          .item1{
             background: url("../assets/images/plat_icon5.png");
             text-indent: 66px;
          }
          .item2{
             background: url("../assets/images/plat_icon6.png");
             text-indent: 66px;
          }
          .item3{
             background: url("../assets/images/plat_icon7.png");
             text-indent: 66px;
          }
          .item4{
             background: url("../assets/images/plat_icon8.png");
             text-indent: 50px;
             margin-right: 0px;
          }
        }
      }
      &.m_70{
        margin-top: 65px;
      }
      &.m_80{
        margin-top: 80px;
      }
    }
    &.guanxi{
      background: #fff9ef;
      height: 188px;
      .title{
        font-size: 20px;
        strong{
          font-size: 25px;
        }
      }
    }

    &.liucheng{
      padding-bottom: 0;
      .bind{
        width: 864px;
        height: 402px;
        margin: 0 auto;
        background: url("../assets/images/buzhou.png") left top no-repeat;
        .item{
          p{
            height: 35px;
            line-height: 35px;
          }
          text-align: left;
          margin-bottom: 104px;
          text-indent: 57px;
          &.item:last-child{
            margin-bottom: 0;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/aboutUs.vue